import { jsx, jsxs } from "react/jsx-runtime";
import { memo, forwardRef } from "react";
import { IconBase } from "src/components/ui/IconBase";
export default memo(forwardRef(function IconSvgArrowLeftLine({
  className,
  "data-test-id": dataTest = "IconArrowLeftLine",
  ...props
}, ref) {
  return /* @__PURE__ */ jsx(IconBase, { ...props, "data-test-id": dataTest, className, innerRef: ref, children: /* @__PURE__ */ jsxs("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx("g", { clipPath: "url(#clip0_4134_10934)", children: /* @__PURE__ */ jsx("path", { d: "M5.2185 7.33336H13.3332V8.6667H5.2185L8.7945 12.2427L7.85184 13.1854L2.6665 8.00003L7.85184 2.8147L8.7945 3.75736L5.2185 7.33336Z", fill: "currentColor" }) }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_4134_10934", children: /* @__PURE__ */ jsx("rect", { width: 16, height: 16, fill: "white" }) }) })
  ] }) });
}));
